export default "__VITE_ASSET__BPiSpjPR__"